import { ModalService, SimpleMessageService, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReleaseDto } from 'src/app/models/release/release-dto';
import { DeleteReleaseWarningModalComponent } from '../delete-release-warning-modal/delete-release-warning-modal.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReleaseIsVisibleDto } from 'src/app/models/release/release-dto';
import { ForgeService } from 'src/app/services/forge.service';
import { NgStyle, DatePipe } from '@angular/common';

@Component({
    selector: 'oaibox-release-row',
    templateUrl: './release-row.component.html',
    styleUrl: './release-row.component.css',
    imports: [
        WebAppCommonModule,
        NgStyle,
        ReactiveFormsModule,
        DatePipe,
    ],
})
export class ReleaseRowComponent implements OnInit, OnDestroy {

  @Input({ required: true }) release!: ReleaseDto;
  @Input() displayButtons?: boolean = true;

  protected releaseIsVisibleForm: ReleaseIsVisibleFormGroup;

  private downloadReleaseZipFileSubscription?: Subscription;
  private releaseIsVisibleSubscription?: Subscription;

  constructor(
    private forgeService: ForgeService,
    private simpleMessageService: SimpleMessageService,
    private modalService: ModalService,
  ) {
    this.releaseIsVisibleForm = new FormGroup({
      isVisible: new FormControl<boolean | null>(null),
    });
  }

  ngOnInit(): void {
    if (this.release.isVisible)
      this.releaseIsVisibleForm.controls.isVisible.patchValue(this.release.isVisible);
  }

  protected downloadReleaseZipFile(releaseName: string, repositoryName: string, repositoryStorageUrl: string): void {
    this.downloadReleaseZipFileSubscription?.unsubscribe();
    this.downloadReleaseZipFileSubscription = this.forgeService.fetchReleaseZipFile(releaseName, repositoryName)
      .subscribe(response => {
        const blob = response.body;
        const filename = repositoryStorageUrl.split('/').pop();

        if (blob && filename) {
          const fileUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(fileUrl);
        }
      });
  }

  protected saveReleaseIsVisible(): void {
    const releaseIsVisibleDto: ReleaseIsVisibleDto = {
      isVisible: this.releaseIsVisibleForm.value.isVisible ?? undefined,
    };
    const successMessage: string = this.releaseIsVisibleForm.value.isVisible
      ? 'Release is visible!'
      : 'Release is not visible!';

    this.releaseIsVisibleSubscription?.unsubscribe();
    this.releaseIsVisibleSubscription = this.forgeService
      .updateReleaseIsVisible(releaseIsVisibleDto, this.release.id)
      .subscribe({
        next: () => {
          this.forgeService.refreshReleases();
          this.simpleMessageService.showSimpleMessage({
            message: successMessage,
            icon: 'fa-solid fa-check-double',
            color: 'success',
          });
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: 'Failed to update Release!',
            icon: 'fa-solid fa-triangle-exclamation',
            color: 'danger',
          });
        },
      });
  }

  protected deleteRelease(): void {
    this.modalService.pushModal({
      component: DeleteReleaseWarningModalComponent,
      inputs: new Map<string, any>([
        ['release', this.release],
      ]),
      closeButtonColor: 'white',
    });
  }

  ngOnDestroy(): void {
    this.downloadReleaseZipFileSubscription?.unsubscribe();
    this.releaseIsVisibleSubscription?.unsubscribe();
  }

}

type ReleaseIsVisibleFormGroup = FormGroup<{
  isVisible: FormControl<boolean | null>,
}>
